module.exports = __webpack_public_path__ + "static/img/event23.37b4d9a.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/event23.png
// module id = qfg7
// module chunks = 1